var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "lf-selector-tree" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _setup.isLoading,
              expression: "isLoading",
            },
          ],
          staticClass: "loading",
        },
        [
          _c(_setup.SpinnerLayerComponent, {
            staticClass: "spinner-layer",
            attrs: { loadingText: _setup.spinnerText },
          }),
        ],
        1
      ),
      _setup.hasTemplates
        ? _c(
            "v-radio-group",
            {
              key: _setup.componentKey,
              on: { change: _setup.getTemplate },
              model: {
                value: _setup.templateSelected,
                callback: function ($$v) {
                  _setup.templateSelected = $$v
                },
                expression: "templateSelected",
              },
            },
            [
              _c("v-treeview", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_setup.isLoading,
                    expression: "!isLoading",
                  },
                ],
                ref: "treeView",
                attrs: {
                  dense: "",
                  "selected-color": "#001978",
                  items: _setup.templateTree,
                  "item-text": "name",
                  "item-disabled": "locked",
                  open: _setup.itemsOpenend,
                },
                scopedSlots: _vm._u(
                  [
                    !_setup.isLoading
                      ? {
                          key: "label",
                          fn: function ({ item }) {
                            return [
                              item.isDirectory
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "is-directory",
                                      on: {
                                        click: function ($event) {
                                          return _setup.onClickDirectory(item)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(" " + _vm._s(item.name) + " "),
                                      _setup.directoryIsEmpty(item)
                                        ? _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  " (" +
                                                    _setup.texts.emptyFolder +
                                                    ")"
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                : _c("span", [_vm._v(_vm._s(item.name))]),
                            ]
                          },
                        }
                      : null,
                    !_setup.isLoading
                      ? {
                          key: "prepend",
                          fn: function ({ item }) {
                            return [
                              item.loading
                                ? _c(_setup.SpinnerLayerComponent, {
                                    staticClass: "spinner-layer-item",
                                  })
                                : _vm._e(),
                              item.isDirectory && !item.loading
                                ? _c("span", {
                                    class: _setup.directoryIcon(item.id),
                                    on: {
                                      click: function ($event) {
                                        return _setup.onClickDirectory(item)
                                      },
                                    },
                                  })
                                : _c(
                                    "div",
                                    { staticClass: "e-filemanager" },
                                    [
                                      !item.loading
                                        ? _c("v-radio", {
                                            staticClass: "radio-tree",
                                            attrs: {
                                              value: item,
                                              "on-icon": _setup.icons.on,
                                              "off-icon": _setup.icons.off,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                            ]
                          },
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "no-result-dialog" },
            [
              !_setup.isLoading
                ? _c(_setup.NoResultsComponent, {
                    attrs: {
                      noResultsIcon: _setup.icons.document,
                      noResultsFirstText: _setup.texts.templatesNotFound,
                      noResultsSecondText: _setup.texts.templatesFromSettings,
                      withBorders: false,
                      verticalAlignCenter: true,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }